<div class="container">
  <h2>Notification Settings</h2>
  <div class="row">
    <div class="col-md-12">
        <mat-card appearance="outlined">
            <mat-card-content>
        <div>
          <table class="table">
            <tr>
              <th>Category</th>
              <th>Description</th>
              <th>Opt Out Of All per Category</th>
              <th>Email</th>
              <th>SMS Messages</th>
              <th>Phone Calls</th>
            </tr>
            <tbody>
              <tr *ngFor="let notification_setting of notification_setting_model">
                <td>{{ notification_setting.notification_category.name}}</td>
                <td>{{ notification_setting.notification_category.description }}</td>
                <td>
                    <div *ngIf="notification_setting.notification_category.opt_out_allowed === true">
                        <button mat-flat-button color="primary" (click)="optOutOfAll(notification_setting.notification_category)">Opt Out of All</button>
                    </div>
                    <div *ngIf="notification_setting.notification_category.opt_out_allowed === false">
                        <span class="greyed-out">At least one Channel is required</span>
                    </div>
                </td>
                 <td>
                    <div class="input-cell">
                        <mat-slide-toggle color="primary" [disabled]="!requiredCheck(notification_setting.email_opt_out)" (change)="update(notification_setting.email_opt_out)" [checked]="notification_setting.email"></mat-slide-toggle>                        
                    </div>
                </td>
                <td>
                    <div class="input-cell">
                        <mat-slide-toggle color="primary" [disabled]="!requiredCheck(notification_setting.sms_opt_out)" (change)="update(notification_setting.sms_opt_out)" [checked]="notification_setting.sms"></mat-slide-toggle>                        
                    </div>
                </td>
                <td>
                    <div class="input-cell">
                        <mat-slide-toggle color="primary" [disabled]="!requiredCheck(notification_setting.phone_opt_out)" (change)="update(notification_setting.phone_opt_out)" [checked]="notification_setting.phone"></mat-slide-toggle>                        
                    </div>
                </td>                
              </tr>
            </tbody>
          </table>
        </div>
            </mat-card-content>
      </mat-card>        
    </div>    
  </div>
</div>